import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class CampCareBookingApiService {

    constructor(private http: ApiHttpClient) { }

    public getCalendarData(request: camps.CampCareBookingCalendarRequest): Observable<api.OperationResultValue<camps.CampCareBookingCalendarData>> {
        return this.http.post<api.OperationResultValue<camps.CampCareBookingCalendarData>>(`campcarebooking/calendar`, request, true);
    }
}
